<template>
    <fragment>
        <!-- Grid Count-->
        <div class="grid_total" v-if="isTotalCount">
            Total&nbsp;Count&nbsp;
            <em>{{ totalCount | numberFormat }}</em>
        </div>
        <grid
            v-if="gridId != null && gridId != ''"
            :id="gridId"
            :ref="gridId"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :pageOptions="gridProps.pageOptions"
            :theme="gridProps.theme"
            :language="gridProps.language"
            :isTotalCount="isTotalCount"
            @click="onClick"
            @check="onCheck"
            @uncheck="onCheck"
            @mousedown ="onMouseDown"
        />
    </fragment>
</template>

<script>

/**
 * Toast Grid
 * ----------
 * Reference Doc
 * https://github.com/nhn/tui.grid/blob/master/packages/toast-ui.vue-grid/docs/getting-started.md
 */
import Vue                      from 'vue';
import { Grid }                 from '@toast-ui/vue-grid'
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import $                        from 'jquery';
import axios                    from 'axios';
import qs                       from 'query-string';
import moment                   from 'moment';
import store                    from '@/vuex/store';
import SDLLocale                from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil }  from '@/utils';
import { EventBus }             from '@/utils/EventBus';

const fetchGridData = form => axios.post(
    `${SDLUtil.API_URL}/basis/myKnowledge/serviceScript/serviceScriptSearch.skp`,
    qs.stringify(form),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name : 'HQContentsListGrid',
    components: {
        'grid' : Grid
    },
    props : {
        'gridId'        : { required : true },
        'columns'       : { type : Array, default : [] },
        'data'          : { type : Array, default : [] },
        'options'       : { type : Object },
        'pageOptions'   : { type : Object },
        'theme'         : { type : [String, Object], default: 'clean' },
        'language'      : { type : String, default : SDLUtil.getI18nLanguage() || 'en'},
        'click'         : { type : Function },
        'isTotalCount'  : { defult : false }
    },
    data() {
        return {
            totalCount: 0,
            orderColArray: [ "KNOWLEDGE_TITLE", "STATUS_NM", "REG_DT", "DUE_DATE", "REG_USER_NM" ],
            sortColumn: {
                columnName: '',
                orderColName: '',
                ascending: null
            }
        }
    },
    computed: {
        ...mapGetters({
            locale: 'getLocale',
        }),
        getColumns() {
            return this.columns;
        }
    },
    watch: {
        totalCount(newTotCnt) {
            this.totalCount = newTotCnt;
            this.$emit('grid-total-count', newTotCnt);
        }
    },
    methods: {
        // Grid event - onClick
        onClick(e) {
            // Occurs when a mouse button is clicked on the Grid.
            // column header
            if(e.targetType == 'columnHeader' && e.columnName !== '_checked') {
                // column sorting 이 변경된 경우
                let colName = e.columnName, orderColName = '',
                    colEl = e.nativeEvent.target, sort = "";
                if( colEl.getAttribute('class').includes('tui-grid-btn-sorting') ) {
                    if(colEl.getAttribute('class').includes('tui-grid-btn-sorting-down')) {
                        sort = false;

                    } else if(colEl.getAttribute('class').includes('tui-grid-btn-sorting-up')) {
                        sort = true;

                    } else {
                        colName = '', orderColName = '', sort = null;
                    }

                    // 컬럼 앞에 Alias 를 붙여준다.
                    if( _.includes(this.orderColArray, colName) && colName === 'REG_DT' ) {
                        orderColName = 'REG_DT_ODER';

                    } else if( _.includes(this.orderColArray, colName) && colName === 'DUE_DATE' ) {
                        orderColName = 'DUE_DATE_ORDER';

                    } else if( _.includes(this.orderColArray, colName) && colName === 'STATUS_NM' ) {
                        orderColName = 'STATUS';

                    } else if( _.includes(this.orderColArray, colName) ) {
                        orderColName = colName;
                    }

                    this.sortColumn = { columnName: colName, orderColName: orderColName, ascending: sort };

                    // sort parameter 를 KnowledgeSearch.vue에 전달한다.
                    EventBus.$emit('hq-cont-sort-search', this.sortColumn);

                } else {
                    return false;

                }

            // cell click
            } else if(e.targetType == "cell") {
                if ((typeof e.rowKey) === "undefined") return;
                let rowData = this.$refs[this.gridId].invoke('getData');

                if(!SDLUtil.isNull(this.click)) this.click(e, rowData, this.$refs[this.gridId]);

            } else if(e.targetType == 'columnHeader' && e.columnName === '_checked') {
                let targetEl = e.nativeEvent.target;
                if(targetEl.tagName === 'TH') {
                    targetEl = e.nativeEvent.target.firstElementChild.firstElementChild;
                };

                let allChecked = targetEl.checked;
                let rowData = this.$refs[this.gridId].invoke('getData'), rtnList = [];

                if(allChecked) {
                    for(let row of rowData) {
                        if(row['STATUS'] === 'R'){
                            rtnList.push({
                                KNOWLEDGE_ID: row['KNOWLEDGE_ID'],
                                SERVICE_SCRIPT_ID: row['SERVICE_SCRIPT_ID'],
                                STATUS: row['STATUS'],
                                rowKey: row.rowKey
                            });
                        }
                    }
                } else {
                    rtnList = [];
                }

                EventBus.$emit('hq-cont-checked-list', rtnList);

            } else {
                return false;
            }

        },
        // Grid event - onCheck
        onCheck(e) {
            let rowData = this.$refs[this.gridId].invoke('getData'),
                rtnList = [];

            let idx = _.findIndex(rowData, function(r){ return r.rowKey === e.rowKey });
            if(rowData[idx].STATUS === 'R') {
                for(let row of rowData) {
                    if(row._attributes.checked) {
                        if(row['STATUS'] === 'R') {
                            rtnList.push({
                                KNOWLEDGE_ID: row['KNOWLEDGE_ID'],
                                SERVICE_SCRIPT_ID: row['SERVICE_SCRIPT_ID'],
                                STATUS: row['STATUS'],
                                rowKey: row.rowKey
                            });
                        }
                    }
                };

                EventBus.$emit('hq-cont-checked-list', rtnList);
            };
        },
        onMouseDown(e){
            if(SDLUtil.isIE11()) {
                if(e.targetType == 'columnHeader' && e.columnName === '_checked') {
                    let targetEl = e.nativeEvent.target;
                    if(targetEl.tagName === 'TH') {
                        targetEl = e.nativeEvent.target.firstElementChild.firstElementChild;
                    };

                    let allChecked = !targetEl.checked; // IE 에서는 반대로 동작함
                    let rowData = this.$refs[this.gridId].invoke('getData'), rtnList = [];

                    if(allChecked) {
                        for(let row of rowData) {
                            if(row['STATUS'] === 'R'){
                                rtnList.push({
                                    KNOWLEDGE_ID: row['KNOWLEDGE_ID'],
                                    SERVICE_SCRIPT_ID: row['SERVICE_SCRIPT_ID'],
                                    STATUS: row['STATUS'],
                                    rowKey: row.rowKey
                                });
                            }
                        }
                    } else {
                        rtnList = [];
                    }

                    EventBus.$emit('hq-cont-checked-list', rtnList);
                }
            }
        },
        loadPropsData() {
            if(this.gridProps.data.length > 0) {
                this.totalCount = this.gridProps.data.length;
                this.$refs[this.gridId].invoke('resetData', this.gridProps.data);

            } else {
                this.$refs[this.gridId].invoke('resetData', []);
            }
        },
        async loadData(form) {
            SDLUtil.showLoadingBar(true);
            if(form !== undefined) {
                const response = await fetchGridData(form)
                    .then(res => {
                        let gridData = [],
                            data = res.data;

                        this.totalCount = data.totalCount;

                        if(data.result.rowData) {
                            gridData = data.result.rowData;
                            this.$refs[this.gridId].invoke('resetData', gridData);

                            if(!SDLUtil.isNull(this.sortColumn.columnName)) {
                                this.$refs[this.gridId].invoke('sort', this.sortColumn.columnName, this.sortColumn.ascending, false);
                            }

                            let rowData = this.$refs[this.gridId].invoke('getData');
                            for(let row of rowData) {
                                if(row['STATUS'] !== 'R' || row['DEL_YN'] === 'Y'){
                                    this.$refs[this.gridId].invoke('disableRowCheck', row.rowKey);
                                }
                            }

                            for(let i = 0; i < gridData.length; i++){
                                this.$refs[this.gridId].invoke('addRowClassName', i, 'cur_pointer');
                            }
                        }
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                        SDLUtil.showLoadingBar(false);
                    });

            } else {
                this.loadPropsData();
            }

            SDLUtil.showLoadingBar(false);
        },
        /**
         *  grid setColumns
         *  @param (array) columns
         */
        setColumns(newCols = []) {
            if(SDLUtil.isNull(newCols)) {
                return false;
            };

            this.$refs[this.gridId].invoke('setColumns', newCols);
            this.$refs[this.gridId].invoke('refreshLayout');
        },
        /**
         * @function setColumnElement
         * @param (Object) changeObject : Grid row number, Column name, Change element
         * @description Toast grid 에서 column의 element를 변경하는 function
         */
        setColumnElement(chgObj) {
            if(SDLUtil.isNull(chgObj)) {
                //Vue.$log.warn("[setColumnElement] change object is null");
                return false;
            };

            let arr = document.getElementsByClassName('tui-grid-cell');
            Array.from(arr).forEach(el => {
                if(el.getAttribute('data-row-key') == chgObj.rowNo
                && el.getAttribute('data-column-name') == chgObj.colNm) {
                    while (el.firstChild) {
                        el.removeChild(el.firstChild);
                    };

                    el.appendChild(chgObj.cEl);
                }
            });
        },
        refreshGrid() {
            this.$refs[this.gridId].invoke('refreshLayout');
        }
    },
    created() {
        this.gridProps = {
            data: this.data,
            columns: this.columns,
            options: {
                selectionUnit: ['row'],
                useClientSort: true,
                showDummyRows: true,
                rowHeight: 48,
                rowHeaders: ['checkbox']
            },
            pageOptions: this.pageOptions,
            theme: {
                name: 'clean',
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    }
                },
            },
            language: {
                name: this.language,
                value: StringUtil.gridMessageMap(this.language)
            }
        };

        // EventBus 를 통해 search component 에서 넘어온 formData를 처리
        EventBus.$on('hq-cont-grid-search', form => { this.loadData(form); });
        // 그리드가 그려져있는 DOM이 처음 화면 로딩시 display:none 일 경우, display 로 변경 때 호출 -> EventBus.$emit('grid-refresh');
        EventBus.$on('hq-cont-grid-refresh', () => { this.refreshGrid(); });
        // 그리드 컬럼셋 변경 이벤트
        EventBus.$on('hq-cont-grid-set-column', (newCols) => { this.setColumns(newCols); });
        // 그리드 컬럼 Element 변경 이벤트
        EventBus.$on('hq-cont-grid-change-column-element', chgObj => { this.setColumnElement(chgObj); });
    },
    mounted() {
        this.loadData();
        //this.$refs[this.gridId].invoke('setWidth', '100%');
        //this.$refs[this.gridId].invoke('setBodyHeight', 400);
    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('hq-cont-grid-search');
        EventBus.$off('hq-cont-grid-refresh');
        EventBus.$off('hq-cont-grid-set-column');
        EventBus.$off('hq-cont-grid-change-column-element');
    }
};
</script>

<style scoped>
.grid_total {display:block;font-size:13px;color:#333;margin-bottom:7px;margin: 14px 0 11px;float:left;}
.grid_total > em {color:#4e65cc;font-weight:600;}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/myKnowledge/serviceScript/HQContentsListGrid.vue